import { getPlatform } from "@/features/identity/constants/platforms";
import { isSafeWebUrl } from "@/features/identity/validation";

const clean = (v) => (typeof v === "string" && v.trim() ? v.trim() : null);

// Pure, UI-free identity shape consumed by card templates (and later public profile, signature, wallet, PWA).
export function buildStructuredIdentity(profile, links = [], { canonicalUrl = null } = {}) {
  const website = clean(profile?.website);
  return {
    fullName: clean(profile?.full_name),
    title: clean(profile?.professional_title),
    company: clean(profile?.company_name),
    photoUrl: clean(profile?.profile_photo_url),
    logoUrl: clean(profile?.company_logo_url),
    email: clean(profile?.email),
    phone: clean(profile?.phone),
    website: website && isSafeWebUrl(website) ? website : null,
    bio: clean(profile?.bio),
    links: links
      .filter((l) => l.is_visible && isSafeWebUrl(l.url))
      .sort((a, b) => a.display_order - b.display_order)
      .map((l) => ({ platform: getPlatform(l.platform).key, url: l.url.trim() })),
    publicProfileUrl: canonicalUrl,
    qrValue: canonicalUrl,
  };
}
